module.exports = __webpack_public_path__ + "img/59.d253231d.svg";